// extracted by mini-css-extract-plugin
module.exports = {"shopTheRoomDetailWrapper":"v1_shopTheRoomDetailWrapper__2KLb_"};